<template>
  <div class="home-main">
    ユーザー名：{{ user.get('username') }}
    権限：{{ type }}
    <user-total v-if="isAdmin" />
    <edit-main v-if="isAdmin" />
  </div>
</template>

<script>
import Parse from '@/parse'
import EditMain from '@/components/Home/EditMain'
import UserTotal from '@/components/Home/UserTotal'

export default {
  components: { EditMain, UserTotal },
  computed: {
    user: function () {
      return Parse.User.current()
    },
    type: function () {
      if (this.isAdmin) {
        return '管理者'
      }
      return '一般'
    },
    isAdmin: function () {
      return this.user.get('admin')
    },
  },
}
</script>

<style scoped lang="scss">
</style>
